/* eslint-disable max-len */
const FilterIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M5.99999 5.5H19C19.2918 5.60236 19.5199 5.83401 19.6177 6.12742C19.7155 6.42084 19.6721 6.743 19.5 7L14.5 12.5V19.5L10.5 16.5V12.5L5.49999 7C5.32792 6.743 5.28445 6.42084 5.38225 6.12742C5.48006 5.83401 5.70813 5.60236 5.99999 5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default FilterIcon;
